import Manage from './manage_cf'
import { connect } from 'react-redux'
import { getCampaignSelector } from 'redux/selectors/campaign'
import { push } from 'react-router-redux'
import { glimpseRoute } from 'lib/route_utils'
import { createDNWTransaction } from 'client/redux/modules/dnw_transaction'
import { TOAST_NOTIFICATIONS } from 'shared/shared_consts'

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const canChipInAndCanDonate = campaign.can_chip_in && campaign.can_donate
  const canDonateGNC =
    Boolean(campaign.charity) &&
    canChipInAndCanDonate &&
    Boolean(campaign.is_owner) &&
    state.flags.dnw_payment
  const canPledge =
    (campaign.is_owner && campaign.can_chip_in) || canChipInAndCanDonate

  return {
    canDonateGNC: canDonateGNC,
    canPledge: canPledge,
    charity: campaign.charity,
    currencyCode: campaign.currency,
    currentValue: campaign.current_value + campaign.pledge,
    goal: campaign.goal,
    hasChippedIn: campaign.current_value > 0,
    hasCurrencyBalance: campaign.has_currency_balance,
    hasMoneybox: campaign.moneybox_amount > 0,
    isDNWPayment: state.flags.dnw_payment,
    showUpdateSuccess:
      state.toast_notification[TOAST_NOTIFICATIONS.EDIT_SUCCESS],
    paypalDomain: state.geo.paypalDomain,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onTransfer() {
      dispatch(push({ pathname: glimpseRoute('edit', 'transfer') }))
    },
    onDonate(id) {
      dispatch(
        createDNWTransaction({
          campaignId: id,
          hasFullPageDonationRedirect: true,
        })
      )
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Manage)
